export default "__VITE_ASSET__D8T9NDOV__"